import React, { ReactNode } from 'react';
import SVG from '@/components/SVG/SVG';
import { useTranslation } from 'react-i18next';
import { CenterLayout } from '@/components/Approval/@components/NoData/styles';

type P = {
  title?: ReactNode;
};
const NoData = ({ title }: P) => {
  const { t } = useTranslation();

  return (
    <CenterLayout>
      <SVG
        name="empty"
        width={40}
        height={40}
        viewBox="0 0 40 40"
        className="empty svg-icon"
      />
      {title ? title : <div>{t('조건에 해당하는 문서가 없어요.')}</div>}
    </CenterLayout>
  );
};
export default NoData;
